import ButtonBase from "@mui/material/ButtonBase";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { MEAL_SCHEDULE } from "../../../mealPlanPage/constants";
import { getMealStatus, MEAL_STATUSES } from "../../../mealPlanPage/utils";
import styles from "./scheduleMealTimings.module.css";

const ScheduleMealTimings = ({ activeMealType, setActiveMealType, selectedDate }: { activeMealType: string, setActiveMealType: React.Dispatch<React.SetStateAction<string>>, selectedDate: Date }) => {
  const handleMealTimeClick = (mealTime: string) => {
    const normalisedMealTime = mealTime.toLowerCase();
    setActiveMealType(normalisedMealTime);
  };

  return (
    <Grid className={styles.meal_time_container}>
      {MEAL_SCHEDULE.map((meal, index) => {
        const { mealType } = meal;
        const mealStatus = getMealStatus(mealType, selectedDate);
        const isDisabled = mealStatus === MEAL_STATUSES.PAST;
        const isActive = activeMealType === mealType;
        return (
          <ButtonBase
            className={`${styles.meal_time_button} ${isDisabled ? styles.meal_time_button_disabled : isActive ? styles.meal_time_button_active : ''}`}
            disabled={isDisabled}
            key={meal.mealType}
            onClick={() => handleMealTimeClick(mealType)}
          >
            <Typography className={styles.meal_type_text} variant="caption4LightOutfit">
              {mealType}
            </Typography>
          </ButtonBase>
        );
      })}
    </Grid>
  );
};

export default ScheduleMealTimings;
